/* eslint-disable */
export var tiggerLcdEditor = false;

export default function init(Blockly, profile, img_path) {
    Blockly.Blocks.lcd = {};
    Blockly.Blocks.lcd.style = 'lcd_blocks';
    Blockly.Blocks.lcd_begin_i2c = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.lcd.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.LCD)
                .appendField(new Blockly.FieldImage(img_path + "arduino/lcd2_i2c.svg", 120, 45))
                .appendField(Blockly.Msg.LCD_I2C_BEGIN)
                .appendField(new Blockly.FieldDropdown([
                ["2x16", "2x16"],
                ["4x20", "4x20"]
                ]), "SIZE")
                .appendField(Blockly.Msg.LCD_I2C_ADDRESS)
                .appendField(new Blockly.FieldDropdown([
                ["0x20", "0x20"],
                ["0x21", "0x21"],
                ["0x22", "0x22"],
                ["0x23", "0x23"],
                ["0x24", "0x24"],
                ["0x25", "0x25"],
                ["0x26", "0x26"],
                ["0x27 *", "0x27"],
                ["0x38", "0x39"],
                ["0x3A", "0x3A"],
                ["0x3B", "0x3B"],
                ["0x3C", "0x3C"],
                ["0x3D", "0x3D"],
                ["0x3E", "0x3E"],
                ["0x3F *", "0x3F"]
                ]), "ADDR");
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.lcd_callbackEditor = function() {
        return function() {
            tiggerLcdEditor = true;
        };
    };
    Blockly.Blocks.lcd_customchar = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.lcd.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.LCD)
                .appendField(new Blockly.FieldImage(img_path + "arduino/lcd2_i2c.svg", 120, 45));
            this.appendDummyInput("").appendField(Blockly.Msg.LCD_DEFINE + " " + Blockly.Msg.LCD_SYMBOL).appendField(new Blockly.FieldDropdown([
                ["1", "1"],
                ["2", "2"],
                ["3", "3"],
                ["4", "4"],
                ["5", "5"],
                ["6", "6"],
                ["7", "7"],
                ["8", "8"]
            ]), "NUM").appendField(new Blockly.FieldTextInput(""), "DATA");
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null);
            this.setInputsInline(!0);
        },
        customContextMenu: function(options) {
            if (this.isInFlyout) return;
            tiggerLcdEditor = false;
            if (!this.isCollapsed()) {
                var option;
                option = {
                    text:     Blockly.Msg.LCD_EDITOR,
                    callback: Blockly.Blocks.lcd_callbackEditor(),
                    enabled:  true
                };
            options.push(option);
            }
          },
    };
    Blockly.Blocks.lcd_print_customchar = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.appendDummyInput("")
                .appendField(Blockly.Msg.LCD)
                .appendField(new Blockly.FieldImage(img_path + "arduino/lcd2_i2c.svg", 120, 45))
            this.setStyle(Blockly.Blocks.lcd.style);
            this.appendDummyInput("").appendField(Blockly.Msg.LCD_PRINT)
                .appendField(Blockly.Msg.LCD_COL)
                .appendField(new Blockly.FieldDropdown([
                    ["0", "0"],
                    ["1", "1"],
                    ["2", "2"],
                    ["3", "3"],
                    ["4", "4"],
                    ["5", "5"],
                    ["6", "6"],
                    ["7", "7"],
                    ["8", "8"],
                    ["9", "9"],
                    ["10", "10"],
                    ["11", "11"],
                    ["12", "12"],
                    ["13", "13"],
                    ["14", "14"],
                    ["15", "15"],
                    ["16", "16"],
                    ["17", "17"],
                    ["18", "18"],
                    ["19", "19"]
            ]), "CURSOR_COLUMN").appendField(Blockly.Msg.LCD_ROW).appendField(new Blockly.FieldDropdown([
                ["0", "0"],
                ["1", "1"],
                ["2", "2"],
                ["3", "3"]
            ]), "CURSOR_ROW");
            this.appendDummyInput("").appendField(Blockly.Msg.LCD_SYMBOL_UPCASE).appendField(new Blockly.FieldDropdown([
                ["1", "1"],
                ["2", "2"],
                ["3", "3"],
                ["4", "4"],
                ["5", "5"],
                ["6", "6"],
                ["7", "7"],
                ["8", "8"]
            ]), "NUM");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.lcd_print = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.appendDummyInput("")
                .appendField(Blockly.Msg.LCD)
                .appendField(new Blockly.FieldImage(img_path + "arduino/lcd2_i2c.svg", 120, 45));
            this.setStyle(Blockly.Blocks.lcd.style);
            this.appendDummyInput("").appendField(Blockly.Msg.LCD_PRINT)
                .appendField(Blockly.Msg.LCD_COL).appendField(new Blockly.FieldDropdown([
                    ["0", "0"],
                    ["1", "1"],
                    ["2", "2"],
                    ["3", "3"],
                    ["4", "4"],
                    ["5", "5"],
                    ["6", "6"],
                    ["7", "7"],
                    ["8", "8"],
                    ["9", "9"],
                    ["10", "10"],
                    ["11", "11"],
                    ["12", "12"],
                    ["13", "13"],
                    ["14", "14"],
                    ["15", "15"],
                    ["16", "16"],
                    ["17", "17"],
                    ["18", "18"],
                    ["19", "19"]
            ]), "CURSOR_COLUMN").appendField(Blockly.Msg.LCD_ROW).appendField(new Blockly.FieldDropdown([
                ["0", "0"],
                ["1", "1"],
                ["2", "2"],
                ["3", "3"]
            ]), "CURSOR_ROW");
            this.appendValueInput("STRINGOUTPUT", "String").setAlign(Blockly.ALIGN_RIGHT);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.lcd_print2 = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.appendDummyInput("")
                .appendField(Blockly.Msg.LCD)
                .appendField(new Blockly.FieldImage(img_path + "arduino/lcd2_i2c.svg", 120, 45));
            this.setStyle(Blockly.Blocks.lcd.style);
            this.appendDummyInput("").appendField(Blockly.Msg.LCD_PRINT);
            this.appendValueInput("CURSOR_COLUMN", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField(Blockly.Msg.LCD_COL);
            this.appendValueInput("CURSOR_ROW",
                "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField(Blockly.Msg.LCD_ROW);
            this.appendValueInput("STRINGOUTPUT", "String").setAlign(Blockly.ALIGN_RIGHT);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.lcd_print2_customchar = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.lcd.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.LCD)
                .appendField(new Blockly.FieldImage(img_path + "arduino/lcd2_i2c.svg", 120, 45))
            this.appendDummyInput("").appendField(Blockly.Msg.LCD_PRINT);
            this.appendValueInput("CURSOR_COLUMN", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField(Blockly.Msg.LCD_COL);
            this.appendValueInput("CURSOR_ROW", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField(Blockly.Msg.LCD_ROW);
            this.appendDummyInput("").appendField(Blockly.Msg.LCD_SYMBOL_UPCASE).appendField(new Blockly.FieldDropdown([
                ["1", "1"],
                ["2", "2"],
                ["3", "3"],
                ["4", "4"],
                ["5", "5"],
                ["6", "6"],
                ["7", "7"],
                ["8", "8"]
            ]), "NUM");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.lcd_clear = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.appendDummyInput("")
                .appendField(Blockly.Msg.LCD)
                .appendField(new Blockly.FieldImage(img_path + "arduino/lcd2_i2c.svg", 120, 45));
            this.setStyle(Blockly.Blocks.lcd.style);
            this.appendDummyInput("").appendField(Blockly.Msg.LCD_CLEAR);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.lcd_display = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.appendDummyInput("")
                .appendField(Blockly.Msg.LCD)
                .appendField(new Blockly.FieldImage(img_path + "arduino/lcd2_i2c.svg", 120, 45))
            this.setStyle(Blockly.Blocks.lcd.style);
            this.appendDummyInput("").appendField(Blockly.Msg.LCD_DISPLAY).appendField(new Blockly.FieldDropdown([
                [Blockly.Msg.LCD_BOOLEAN_ON, "on"],
                [Blockly.Msg.LCD_BOOLEAN_OFF, "off"]
            ]), "DISPLAY");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0,
                null)
        }
    };
    Blockly.Blocks.lcd_backlight = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.appendDummyInput("")
                .appendField(Blockly.Msg.LCD)
                .appendField(new Blockly.FieldImage(img_path + "arduino/lcd2_i2c.svg", 120, 45))
            this.setStyle(Blockly.Blocks.lcd.style);
            this.appendDummyInput("").appendField(Blockly.Msg.LCD_BACKLIGHT).appendField(new Blockly.FieldDropdown([
                [Blockly.Msg.LCD_BOOLEAN_ON, "on"],
                [Blockly.Msg.LCD_BOOLEAN_OFF, "off"]
            ]), "BACKLIGHT");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.lcd_cursor = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.appendDummyInput("")
                .appendField(Blockly.Msg.LCD)
                .appendField(new Blockly.FieldImage(img_path + "arduino/lcd2_i2c.svg", 120, 45))
            this.setStyle(Blockly.Blocks.lcd.style);
            this.appendDummyInput("").appendField(Blockly.Msg.LCD_CURSOR).appendField(new Blockly.FieldDropdown([
                [Blockly.Msg.LCD_BOOLEAN_ON, "on"],
                [Blockly.Msg.LCD_BOOLEAN_OFF, "off"]
            ]), "CURSOR");
            this.appendDummyInput("").appendField(Blockly.Msg.LCD_BLINK).appendField(new Blockly.FieldDropdown([
                [Blockly.Msg.LCD_BOOLEAN_ON, "on"],
                [Blockly.Msg.LCD_BOOLEAN_OFF, "off"]
            ]), "BLINK");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.lcd_scroll = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.lcd.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.LCD)
                .appendField(new Blockly.FieldImage(img_path + "arduino/lcd2_i2c.svg", 120, 45))
            this.appendDummyInput("").appendField(Blockly.Msg.LCD_SCROLL).appendField(new Blockly.FieldDropdown([
                [Blockly.Msg.LCD_LEFT, "left"],
                [Blockly.Msg.LCD_RIGHT, "right"]
            ]), "DIR");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0,
                null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.lcd_drawchar = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.lcd.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.LCD)
            this.appendDummyInput()
                .appendField(new Blockly.FieldImage(img_path + "arduino/lcd2_i2c.svg", 120, 45));
            this.appendDummyInput("")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.LCD_COL)
                .appendField(new Blockly.FieldDropdown([
                    ["0", "0"],
                    ["1", "1"],
                    ["2", "2"],
                    ["3", "3"],
                    ["4", "4"],
                    ["5", "5"],
                    ["6", "6"],
                    ["7", "7"],
                    ["8", "8"],
                    ["9", "9"],
                    ["10", "10"],
                    ["11", "11"],
                    ["12", "12"],
                    ["13", "13"],
                    ["14", "14"],
                    ["15", "15"],
                    ["16", "16"],
                    ["17", "17"],
                    ["18", "18"],
                    ["19", "19"]
                ]), "CURSOR_COLUMN")
                this.appendDummyInput()
                    .setAlign(Blockly.ALIGN_RIGHT)
                    .appendField(Blockly.Msg.LCD_ROW)
                    .appendField(new Blockly.FieldDropdown([
                    ["0", "0"],
                    ["1", "1"],
                    ["2", "2"],
                    ["3", "3"]
                ]), "CURSOR_ROW");
            for (var a = 0; 8 > a; a++) {
                for (var b = this.appendDummyInput(""), c = 0; 5 > c; c++) {
                    b.appendField(new Blockly.FieldCheckboxRound("FALSE"), "R" + a.toString() + "C" + c.toString());
                }
            }
            this.setInputsInline(false);
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
        }
    };
}